import {Provider} from "react-redux";

window._ = require('lodash');

import '@popperjs/core'

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
} catch (e) {
}

const bootstrap = require('bootstrap')

window.bootstrap = bootstrap

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import Alpine from 'alpinejs';

window.Alpine = Alpine;
Alpine.start();

import Echo from 'laravel-echo';

if (process.env.MIX_PUSHER_APP_KEY !== undefined
    &&
    process.env.MIX_PUSHER_APP_KEY
) {
    window.Pusher = require('pusher-js');

    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: 1,
        wsHost: window.location.hostname,
        wsPort: 6001,
        forceTLS: false,
        disableStats: true,
    });
}

import store from "./storeWire";
import {auth} from "./store/slice/auth";

import React from 'react'
import {render} from 'react-dom'
import {createInertiaApp} from '@inertiajs/inertia-react'

import {createApp, h} from 'vue'
import {createInertiaApp as createInertiaAppVue} from '@inertiajs/inertia-vue3'
import {loadProgressBar} from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'

import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

loadProgressBar()

if (inertiajs === undefined) {
    let inertiajs = 'react';
}

if (l_auth !== undefined && l_auth) {

    axios.get(window.location.origin + '/api/user').then((user) => {
        store.dispatch(auth(user.data));

        if (process.env.MIX_PUSHER_APP_KEY !== undefined &&
            process.env.MIX_PUSHER_APP_KEY &&
            user.data) {
            window.Echo.private('App.Models.User.' + user.data.id)
                .notification((data) => {
                    document.dispatchEvent(new CustomEvent("authLiveNotification", {detail: data}));
                });
        }
    });
}
let app = document.getElementById('app')
if (
    app != undefined
    &&
    app.dataset != undefined
    &&
    app.dataset.page != undefined
    &&
    name != undefined
) {

    if (inertiajs == 'react') {
        createInertiaApp({
            resolve: name => require(`./Pages/${name}`),
            setup({el, App, props}) {
                render(
                    <Provider store={store}>
                        <ToastContainer/>
                        <App {...props} />
                    </Provider>, el)
            },
        })
    }

    if (inertiajs == 'vue') {
        createInertiaAppVue({
            resolve: name => require(`./Pages/${name}`),
            setup({el, App, props, plugin}) {
                createApp({render: () => h(App, props)})
                    .use(plugin)
                    .mount(el)
            },
        })
    }
}

require('./system')
